// import Box from "@mui/material/Box";
import { env } from '../env';
import Grid from "@mui/material/Grid";
import { Skeleton, Typography } from "@mui/material";
import List from "@mui/material/List";
// import { reason } from "../asset/data";
import { ReasonChoice, ChoiceHistory } from "../component";
import { useState } from "react";
import { useEffect } from "react";
import { reason } from '../asset/data';

function Reason({ setPage, page }) {
  const [reasons, setReasons] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
      setLoading(true);
      const request = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          mode: "cors",
          body: JSON.stringify({
              LK: env.REACT_APP_LICENCE_KEY,
              ENVID: env.REACT_APP_ENV_ID,
              PlaceID: page.place.ID
          })
      };
    fetch(
      `${env.REACT_APP_PROXY_BASE_URL}/appointment-type`, request
    )
      .then((res) => res.json())
      .then((res) => {
        setReasons(res.AppointmentTypes);
      })
      .catch((err) => console.log("Appointments fetch error " + err))
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const renderSkeletons = () => {
    return (
      <>
        <Skeleton height={100} width={300} />
        <Skeleton height={100} width={300} />
        <Skeleton height={100} width={300} />
        <Skeleton height={100} width={300} />
        <Skeleton height={100} width={300} />
      </>
    );
  };
  return (
    <Grid container justifyContent="center" spacing={3}>
      {/* Rappel */}
      <ChoiceHistory page={page} setPage={setPage} />

      {/* Motif de consultation */}
      <Grid
        item
        order={{ xs: 2, md: 1 }}
        xs={12}
        md={6}
        justifyContent="center"
        mt={5}
      >
        {/* Titre */}
        <Grid item xs={12}>
                  {reasons === undefined || reasons != null ? (
                      <Typography align="center" variant="h4">
                          Motif de votre consultation ?
                      </Typography>
                  ) : (
                      <Typography align="center" variant="h4">
                      </Typography>
                  )}
        </Grid>

        {/* Choix du motif de la consultation */}

        <Grid container item justifyContent="center">
          <List>
            {reasons === undefined
              ? renderSkeletons()
                          : 
                          (
                reasons != null ?
                reasons?.map((data) => (
                  <div key={data.ID}>
                    <ReasonChoice setPage={setPage} page={page} data={data} />
                  </div>
                )) :
                    (
                        <Typography align="center" variant="h3">
                            Motifs non disponibles
                        </Typography>
                    )
            )}
          </List>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Reason;
